import { Progress } from "@/components/ui/progress";
import { cn } from "@/lib/utils";

export function QuantityBar({
  booked,
  total,
  className,
}: {
  booked: number;
  total: number;
  className?: string;
}) {
  const percent = total > 0 ? (booked / total) * 100 : 0;

  return (
    <div className={cn("w-20 space-y-1", className)}>
      <div className="flex items-center justify-between text-xs text-gray-500">
        <span>{booked}</span>
        <span>/</span>
        <span>{total}</span>
      </div>
      <Progress
        value={percent}
        className="h-1.5 w-full rounded-full bg-gray-200"
        indicatorClassName={cn(
          "rounded-full transition-all duration-300",
          percent < 50
            ? "bg-yellow-400"
            : percent < 80
              ? "bg-orange-400"
              : "bg-green-500",
        )}
      />
    </div>
  );
}
